<script>
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import { mapActions } from 'vuex'

export default {
  name: 'AddContractModal',
  props: {
    provider: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      progress: false,
      suppliers: [],
      supplierSearching: false,
      form: {
        supplier: null,
      },
      rules: {
        supplier: [
          {
            required: true,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('contract', ['addContract']),
    ...mapActions('suppliers', ['searchSuppliersByName']),
    async onSubmit() {
      const formValid = await this.$refs.form.validate().catch(() => false)
      if (!formValid) {
        return
      }
      this.progress = true

      const response = await this.addContract({
        providerId: this.provider.id,
        supplierId: this.form.supplier,
      })

      this.progress = false

      if (response[1] && (new Date() - new Date(get(response, '[1]["created_at"]')) > 5000)) {
        this.$notify({
          type: 'warning',
          title: 'Warning',
          message: 'This contract already exists',
        })
        return this.toContract(response[1])
      }

      this.$notifier({
        response,
        successMsg: 'Contract successfully added',
      }).then(success => success && this.toContract(success))
    },
    toContract(success) {
      this.$emit('update:visible', false)
      this.$modal.self.hide()
      this.$router.push({
        name: 'contract-details',
        params: { id: success.id },
      })
    },
    searchSuppliers: debounce(async function(string) {
      this.supplierSearching = true
      this.suppliers = await this.searchSuppliersByName(string)
      this.supplierSearching = false
    }, 300),
  },
}
</script>

<template>
  <base-modal
    title="Add Contract"
    :check-form-changes="form"
  >
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      :disabled="progress"
      :rules="rules"
    >
      <el-form-item
        label="Provider Name"
      >
        <el-input
          :value="provider.name"
          disabled
        />
      </el-form-item>
      <el-form-item
        label="Supplier"
        prop="supplier"
      >
        <el-select
          v-model="form.supplier"
          :remote-method="searchSuppliers"
          :loading="supplierSearching"
          loading-text="Searching supplier by name..."
          placeholder="Start typing supplier name..."
          filterable
          remote
        >
          <el-option
            v-for="(item, idx) in suppliers"
            :key="idx+'s'"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <div :class="$style.controls">
        <el-button
          type="primary"
          :loading="progress"
          class="el-button--wide"
          @click.stop="onSubmit"
        >
          Save
        </el-button>
      </div>
    </el-form>
  </base-modal>
</template>

<style lang="scss" module>
.status {
  margin-left: rem(14px);
}

.controls {
  display: flex;
  justify-content: center;
}
</style>
